import {
  Check,
  CheckCircle,
  CheckSquare,
  Users,
  Bell,
  Star,
  UserPlus,
  Calendar,
  CalendarCheck,
  Search,
  Send,
  TrendingUp,
  FilePlus,
  Settings,
  Inbox,
  Briefcase,
  MapPin,
  Clock,
  PhoneOff,
  MessageCircle,
  FileSpreadsheet,
  AlarmClock,
  EyeOff,
  LayoutGrid,
  Zap,
  Network,
  Target,
  ShieldCheck,
  CreditCard,
  Store,
  User,
  Circle,
  type LucideIcon,
} from 'lucide-react';

const ICONS: Record<string, LucideIcon> = {
  check: Check,
  'check-circle': CheckCircle,
  'check-square': CheckSquare,
  users: Users,
  bell: Bell,
  star: Star,
  'user-plus': UserPlus,
  calendar: Calendar,
  'calendar-check': CalendarCheck,
  search: Search,
  send: Send,
  'trending-up': TrendingUp,
  'file-plus': FilePlus,
  settings: Settings,
  inbox: Inbox,
  briefcase: Briefcase,
  'map-pin': MapPin,
  clock: Clock,
  'phone-off': PhoneOff,
  'message-circle': MessageCircle,
  'file-spreadsheet': FileSpreadsheet,
  'alarm-clock': AlarmClock,
  'eye-off': EyeOff,
  'layout-grid': LayoutGrid,
  zap: Zap,
  network: Network,
  target: Target,
  'shield-check': ShieldCheck,
  'credit-card': CreditCard,
  store: Store,
  user: User,
};

export function getIcon(name: string): LucideIcon {
  return ICONS[name] ?? Circle;
}

export const ICON_NAMES = Object.keys(ICONS);
